import React from 'react';
import PropTypes from 'prop-types';

const RelatedCategory = props => (
  <a className="related-category-link" href={`${props.baseUrl}${props.url}`}>{props.categoryName}</a>
);

RelatedCategory.propTypes = {
  categoryName: PropTypes.string,
  url: PropTypes.string,
  baseUrl: PropTypes.string,
};

RelatedCategory.defaultProps = {
  categoryName: '',
  url: '',
  baseUrl: '',
};

export default RelatedCategory;



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/RelatedCategory/RelatedCategory.js